module.exports = __webpack_public_path__ + "_assets/img/report.e4dcfb59.svg";